var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"more-list"},[_c('div',{staticClass:"no-data icon-nodata",class:{ hide: !_vm.nodata }}),_c('div',{staticClass:"more a-ta-c",class:{ 'hide': _vm.nodata, 'icon-more': _vm.more },on:{"click":_vm.moreList}},[(_vm.more)?_c('span',{staticClass:"more-btn"},[_vm._v("查看更多")]):_c('span',[_vm._v("没有更多了")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }